<template>
  <main
    class="page"
    role="main"
    aria-labelledby="page-title"
  >
    <header class="page-header">
      <h1
        id="page-title"
        class="h1"
      >
        Dashboard
      </h1>
    </header>

    <!-- Top-Navigation: Hilfe-Button -->
    <teleport to=".top-nav">
      <span
        id="top-nav-help-role-dashboard"
        class="top-nav-help"
      >
        <UiInfoButton title="Hilfe: Rollen-Dashboard">
          <ul>
            <li>Über die Navigation erreichst du alle weiteren Funktionen.</li>
            <li v-if="roleName != 'parent'">Die Meldungen können direkt per Klick auf den Eintrag aufgerufen werden.</li>
            <li v-if="roleName != 'parent'">Über die Schülersuche kannst du dir den derzeitigen Aufenthalt eines Schülers anzeigen lassen.</li>
          </ul>
        </UiInfoButton>
      </span>
    </teleport>

    <component :is="componentName" />
  </main>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount } from 'vue';
import { useAuthStore } from '@/stores/auth';
import AdminDashboard from './dashboards/AdminDashboard.vue';
import TeacherDashboard from './dashboards/TeacherDashboard.vue';
import ParentDashboard from './dashboards/ParentDashboard.vue';
import UiInfoButton from '@/components/UiInfoButton.vue';

const auth = useAuthStore();

const roleName = computed(() => {
  const u = auth.user || {};
  // 1) Rolle per id
  if (u.roleId === 1) return 'admin';
  if (u.roleId === 2) return 'teacher';
  if (u.roleId === 3) return 'parent';
  // 2) Alternativ über Rollen-Arrays
  const raw = u.roles || u.roleCodes || u.scopes || u.permissions || [];
  const list = Array.isArray(raw) ? raw : [];
  const names = list.map(r => typeof r === 'string' ? r : (r?.code || r?.name || '')).map(String);
  if (names.some(n => /(^|[_:\s-])admin(\b|$)/i.test(n))) return 'admin';
  if (names.some(n => /teacher|lehrer/i.test(n))) return 'teacher';
  if (names.some(n => /parent|eltern/i.test(n))) return 'parent';
  // Fallback
  return 'guest';
});

const componentName = computed(() => {
  switch (roleName.value) {
    case 'admin':
      return AdminDashboard;
    case 'teacher':
      return TeacherDashboard;
    case 'parent':
      return ParentDashboard;
    default:
      // Fallback: neutrales Dashboard – hier Teacher als sinnvolle Default-Ansicht
      return TeacherDashboard;
  }
});

// Hilfe-Button vor .profile einsortieren
onMounted(() => {
  const nav = document.querySelector('.top-nav');
  const el = document.getElementById('top-nav-help-role-dashboard');
  if (!nav || !el) return;
  const profile = nav.querySelector('.profile');
  if (profile && profile.parentNode === nav) nav.insertBefore(el, profile);
  else nav.appendChild(el);
});

onBeforeUnmount(() => {
  const el = document.getElementById('top-nav-help-role-dashboard');
  if (el && el.parentNode) el.parentNode.removeChild(el);
});
</script>
